import axios from 'axios';

const url = '/api/category/';

export default {
  getCategories() {
    return axios.get(url).then((response) => response.data);
  },
};
